var EHDI = EHDI || Object.create(null);

EHDI.game = EHDI.game || Object.create(null);

EHDI.PTypeEnum = {
  PA3: 100,
  PA5: 101,
  PA7: 102,
  PB4: 200,
  PB6: 201,
  PC4: 300,
  PC5: 301,
  PD4: 400,
  PD6: 401,
  PE1: 500,
};

EHDI.game.Platform = function () {
    EHDI.aka.Container.call(this);
  };

EHDI.game.Platform.prototype = Object.create(EHDI.aka.Container.prototype);

EHDI.game.Platform.prototype.init = function (type, xPos, yPos) {
    this._type = type;
    this.x = xPos;
    this.y = yPos;
    this.hWidth = this.getPlatformWidth();
    this._assetRight = 0;
    this._assetLeft = 0;
    this._arcEntranceWidth = 380;

    this._platformXPos;
    this._platformWidth;

    this._texture;
    this._sprite;

    this._hitbox;

    this.initHitboxVal();
    this.initSprite();

    if (this._hitbox == undefined) {
      this._hitbox = new EHDI.game.Hitbox(0, this.hWidth, this.hHeight, 0, this._hColor);
      this._hitbox.alpha = 0.4;

      this.addChild(this._hitbox);
    }

    this._platformWidth = this._hitbox.getWidth() + this._assetRight + this._assetLeft;
    this._platformXPos = this.x - this._assetLeft;
  };

EHDI.game.Platform.prototype.initHitboxVal = function () {
  if (this._type < 200) {
    this.hHeight = 100;
    this._hColor = 0x7F0000;
  } else if (this._type < 300) {
    this.hHeight = 200;
    this._hColor = 0x967D00;
  } else if (this._type < 400) {
    this.hHeight = 300;
    this._hColor = 0x0018A0;
  } else if (this._type < 500) {
    this.hHeight = 400;
    this._hColor = 0x007F0E;
  } else {
    this.hHeight = 400;
    this._hColor = 0x007F0E;
  }
};

EHDI.game.Platform.prototype.initSprite = function () {
  if (this._sprite == undefined) {
    this._sprite = EHDI.GetGlobalPool().spritePool.get();
  }

  if (this._type == EHDI.PTypeEnum.PA3) {
    this._texture = EHDI.Assets.images['platform1'];

    this._sprite.texture = this._texture;
    this._sprite.pivot.y = this._texture.height;
    this._sprite.pivot.x = 81;
    this._assetLeft = this._sprite.pivot.x;
    this._assetRight= 104;
  } else if (this._type == EHDI.PTypeEnum.PA5) {
    this._texture = EHDI.Assets.images['platform2'];

    this._sprite.texture = this._texture;
    this._sprite.pivot.y = this._texture.height;
    this._sprite.pivot.x = 75;
    this._assetLeft = this._sprite.pivot.x;
    this._assetRight = 100;
  } else if (this._type == EHDI.PTypeEnum.PA7) {
    this._texture = EHDI.Assets.images['platform3'];

    this._sprite.texture = this._texture;
    this._sprite.pivot.y = this._texture.height;
    this._sprite.pivot.x = 23;
    this._assetLeft = this._sprite.pivot.x;
    this._assetRight = 13;
  } else if (this._type == EHDI.PTypeEnum.PB4) {
    this._texture = EHDI.Assets.images['house1'];

    this._sprite.texture = this._texture;
    this._sprite.pivot.y = this._texture.height;
  } else if (this._type == EHDI.PTypeEnum.PB6) {
    this._texture = EHDI.Assets.images['house4'];

    this._sprite.texture = this._texture;
    this._sprite.pivot.y = this._texture.height;
  } else if (this._type == EHDI.PTypeEnum.PC4) {
    this._texture = EHDI.Assets.images['house2'];

    this._sprite.texture = this._texture;
    this._sprite.pivot.y = this._texture.height;
  } else if (this._type == EHDI.PTypeEnum.PC5) {
    this._texture = EHDI.Assets.images['house5'];

    this._sprite.texture = this._texture;
    this._sprite.pivot.y = this._texture.height;
  }
  else if (this._type == EHDI.PTypeEnum.PD4) {
   this._texture = EHDI.Assets.images['house3'];

   this._sprite.texture = this._texture;
   this._sprite.pivot.y = this._texture.height;
 } else if (this._type == EHDI.PTypeEnum.PD6) {
   this._texture = EHDI.Assets.images['house6'];

   this._sprite.texture = this._texture;
   this._sprite.pivot.y = this._texture.height;
 } else if (this._type == EHDI.PTypeEnum.PE1) {
   this._texture = EHDI.Assets.images['ark'];

   this._sprite.texture = this._texture;
   this._sprite.pivot.y = this._texture.height;
   this._assetRight = 100;
 }

 this.addChild(this._sprite);
};

EHDI.game.Platform.prototype.getPlatformWidth = function () {
  if (this._type == EHDI.PTypeEnum.PA3) {
    return 300;
  } else if (this._type == EHDI.PTypeEnum.PA5 || this._type == EHDI.PTypeEnum.PC5) {
    return 500;
  } else if (this._type == EHDI.PTypeEnum.PA7) {
    return 700;
  } else if (this._type == EHDI.PTypeEnum.PB4 || this._type == EHDI.PTypeEnum.PC4 ||
  this._type == EHDI.PTypeEnum.PD4) {
    return 400;
  } else if (this._type == EHDI.PTypeEnum.PB6 || this._type == EHDI.PTypeEnum.PD6) {
    return 600;
  } else {
    return 1000;
  }
}

EHDI.game.Platform.prototype.getPlatformXPos = function () {
  return this._platformXPos;
}

EHDI.game.Platform.prototype.getHeight = function () {
  return this._hitbox.getHeight();
};

EHDI.game.Platform.prototype.getWidth = function () {
  return this._platformWidth;
};

EHDI.game.Platform.prototype.getTopYPos = function () {
  return this.y - this._hitbox._top;
};

EHDI.game.Platform.prototype.getHitbox = function () {
  return this._hitbox;
};

EHDI.game.Platform.prototype.getplatformY = function (hitbox) {
  return this._hitbox.getGlobalTopY();
};

EHDI.game.Platform.prototype.getType = function () {
  return this._type;
}

EHDI.game.Platform.prototype.update = function (newX) {
  this._hitbox.update(this.x + newX, this.y);
};
